module.exports = __webpack_public_path__ + "static/media/versioncontrol.a36da67c.svg";